import { usePostTablesInventoryApplications } from '@ipfabric/api-client/client/model/aim/aim';
import { PageHeader } from '@ipfabric/ui-components/PageHeader/PageHeader';
import {
  TabbedTables,
  type TableTabRoute,
} from 'components/TabbedTables/TabbedTables';
import { type FC, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnapshotId } from 'utils/hooks/useSnapshotId';
import { renderQuery } from 'utils/react-query/renderQuery';
import {
  APPLICATION_ID_PARAM,
  applicationDetailTabDefs,
} from './applicationDetailTabs';

const APPLICATIONS_LIST_PATH = '/inventory/applications';

export const ApplicationDetailPage: FC = () => {
  const navigate = useNavigate();
  const { [APPLICATION_ID_PARAM]: applicationId } = useParams();
  const base = `${APPLICATIONS_LIST_PATH}/${applicationId}`;

  const tabs = useMemo<TableTabRoute[]>(
    () =>
      applicationDetailTabDefs.map((tab) => ({
        path: `${base}/${tab.segment}`,
        getTabLabel: () => tab.title,
        icon: tab.icon,
        default: tab.default,
      })),
    [base],
  );

  const snapshotId = useSnapshotId();
  const applicationQuery = usePostTablesInventoryApplications({
    snapshot: snapshotId ?? '$last',
    columns: ['name'],
    filters: { id: ['eq', applicationId] },
    pagination: { start: 0, limit: 1 },
  });

  const applicationLabel = renderQuery({
    query: applicationQuery,
    renderStaleDataOnMount: true,
    pending: () => null,
    error: () => applicationId,
    success: (data) => data.data[0]?.name || applicationId,
  });

  return (
    <div className='flex flex-col flex-1'>
      <PageHeader
        width='full'
        label={applicationLabel}
        onBackButtonClick={() => navigate(APPLICATIONS_LIST_PATH)}
      />
      <div className='p flex flex-1'>
        <div className='flex flex-1 overflow-hidden rounded-lg drop-shadow'>
          <TabbedTables rootPath={base} tabs={tabs} variant='outer' />
        </div>
      </div>
    </div>
  );
};
